import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDatabaseDescriptionParams {
  id: string;
  description: string;
}

export class SetDatabaseDescriptionRequest extends Request<IDatabaseDescriptionParams, IResult> {
  constructor(params: IDatabaseDescriptionParams) {
    super('setDatabaseDescription', params);
  }
}
